// removed by extract-text-webpack-plugin
module.exports = {"button":"_2GeM1QamELavGV6xwLOnyG","primary":"_2_wpnorMx9Cu_Gfbhkx3K4","borderWeight--thick":"YVuD2fDzr7CD7S4B3tIxW","success":"_3lCRW9fWeFEOKSYnmAN44u","intro":"_328UI6YGwCgxIJi_JSk_hv","muted":"n7e3mhXyCWmlLFHfHu4gF","audio":"NqTGjFROONWGAkhF40jf5","round":"_2yG-QTiZSh1qQDrxaS3ZY4","facebook":"_38FFuvz8vL3SuTtp3Cg-Ci","secondary":"rGHnB1JqSg1bCTqUya5zf","disabled":"_6Aua3puNFR9F04MDCzWly","sizeSmall":"O0v0mTyBvHmuVpASQMNH4"};


//////////////////
// WEBPACK FOOTER
// ./src/elements/button/button.scss
// module id = 407
// module chunks = 0